import React from 'react';
import { CardButtonWrapperContainer } from './styles/card-button-wrapper.styled';
const CardButtonWrapper = ({ children, alignment = 'center', }) => {
    return (React.createElement(CardButtonWrapperContainer, { className: "PONCHO-card__button-wrapper", "$alignment": alignment }, children));
};
CardButtonWrapper.CARD_ELEMENT = 'CARD_BUTTON_WRAPPER';
export default CardButtonWrapper;
//# sourceMappingURL=CardButtonWrapper.js.map